<template>
  <div>
    <div class="container-fluid">
      <v-row class="app-course">
        <v-col cols="12" sm="12" md="12">
          <h2>Olá {{ getUser.name }}, <span>bem vindo!</span></h2>
        </v-col>

        <!-- <banner-home></banner-home> -->

        <v-col cols="12" sd="12" md="6" class="mb-5">
          <div class="destaque-busca destaque-busca-app">
            <v-row>
              <v-col cols="12" sm="12" md="4" lg="4" class="wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.4s"
                     data-wow-offset="40">
                <img src="@/assets/home-img-1.png" alt="" class="img-fluid"/>
              </v-col>
              <v-col cols="12" sm="12" md="8" lg="8" class="wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.4s"
                     data-wow-offset="40">
                <h5>Aprender sempre,<br/> a cada momento e em todo lugar!</h5>
                <v-btn dark :to="{name: 'course-list'}">Ver todos os cursos</v-btn>
              </v-col>
            </v-row>
          </div>
        </v-col>

        <v-col cols="12" sm="12" md="6">
          <div class="destaque-busca destaque-busca-app-2">
            <v-row>
              <v-col cols="12" sm="12" md="4" lg="4" class="wow fadeInUp" data-wow-duration="1.2s" data-wow-delay="0.8s"
                     data-wow-offset="40">
                <img src="@/assets/home-img-2.png" alt="" class="img-fluid"/>
              </v-col>
              <v-col cols="12" sm="12" md="8" lg="8" class="wow fadeInUp" data-wow-duration="1.2s" data-wow-delay="0.8s"
                     data-wow-offset="40">
                <v-row>
                  <v-col cols="12" sm="12" md="12" class="pt-0 pb-0">
                    <h5>Faça parte <br/>dessa inovação!</h5>
                    <!-- <p>Vamos transformar juntos a educação da sua instituição.</p> -->
                    <!--<v-btn dark :to="{name: 'course-create-step1'}">Ensine com a gente</v-btn>-->
                    <v-btn dark @click="sendInterest">Ensine com a gente</v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </v-col>

        <v-col cols="12" sm="12" md="12">
          <div class="divisor-app white"></div>
        </v-col>

        <v-col cols="12" sm="12" md="12" v-if="courses.length">
          <h3>Seu progresso</h3>

          <v-row>

            <v-col v-for="(course, $index) in courses" :key="$index" cols="12" sm="12" md="4" lg="3"
                   class="card-course card-course-app card-course-app-home">
              <router-link :to="{ name: 'take-course', params: { course_id: course._id }}">
                <div class="card-course-div">
                  <div :style="{ backgroundImage: 'url(' + course.image + ')' }" class="img-course"
                       v-if="course.image"></div>
                  <div class="img-course" v-else></div>
                  <h4>{{ course.title }}</h4>
                  <h5>{{ course.userName }}</h5>
                  <div class="progresso-course-barra">
                    <div class="progresso-course-barra-valor" :style="`width:${course.percentage}%`"></div>
                    <p>
                      <template v-if="course.percentage > 0">
                        {{ course.percentage }}% concluído
                      </template>
                      <template v-else>
                        Comece agora
                      </template>
                    </p>
                  </div>
                  <br/>
                  <br/>
                  <v-btn class="outline" color="success" dark>
                    <template v-if="course.percentage > 0">
                      Continuar
                    </template>
                    <template v-else>
                      Iniciar curso
                    </template>
                  </v-btn>
                </div>
              </router-link>
            </v-col>

          </v-row>
        </v-col>

      </v-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'
// import CardCourse from '../../components/CardCourse'
// import BannerHome from '../../components/BannerHome'
import { WOW } from 'wowjs'

library.add(faSpinner)

export default {
  name: 'UserHome',
  // components: {CardCourse, BannerHome},
  data () {
    return {
      hasSend: false,
      loading: true,
      search: '',
      courses: [],
      coursesFiltered: [],
      permissionToEdit: false,
      selectedCategories: [],
      selectedPrices: [],
      selectedDuration: []
    }
  },
  computed: {
    ...mapGetters(['permissions', 'getUser'])
  },
  watch: {
    search: function (val) {
      if (!val) {
        this.coursesFiltered = this.courses

        return false
      }

      this.coursesFiltered = this.courses.filter(course => {
        return course.title.toLowerCase().includes(val.toLowerCase())
      })
    },
  },
  methods: {
    getCourses () {
      this.axios.get('/user/course/user').then(response => {
        if (response.data.success) {
          this.coursesFiltered = response.data.courses
          this.courses = response.data.courses
        }

        this.loading = false
      })
    },
    removeCourseFromList (courseId) {
      let indexCourse = this.courses.findIndex(c => {
        return c._id === courseId
      })

      if (indexCourse !== -1) {
        this.courses.splice(indexCourse, 1)
      }
    },
    sendInterest () {
      if (this.hasSend) {
        this.$swal('Já recebemos o seu contato', '', 'success')

        return false
      }

      this.$swal({
        title: 'Você tem interesse em criar cursos na nossa plataforma?',
        text: '',
        type: 'info',
        showCancelButton: true,
        confirmButtonColor: '#8bc34a',
        cancelButtonColor: 'grey',
        confirmButtonText: 'Sim, eu tenho',
        cancelButtonText: 'Não tenho interesse'
      }).then(result => {
        if (result.value) {
          this.axios.get('/user/send-interest').then(response => {
            if (response.data.success) {
              this.hasSend = true

              this.$swal('Obrigado pelo interesse!', 'Você será informado previamente ao lançamento deste módulo.', 'success')
            } else {
              this.$swal('Ops', 'Houve um erro ao informar o interesse', 'error')
            }
          }).catch(err => {
            console.error(err)

            this.$swal('Ops', 'Houve um erro ao informar o interesse', 'error')
          }).finally(() => {
            this.showAlert = true
          })
        }
      })
    }
  },
  created () {
    this.getCourses()
    this.permissionToEdit = this.permissions.createVideo
  },
  mounted () {
    var wow = new WOW({
      live: false
    })
    wow.init()
  }
}
</script>
